module.exports = __webpack_public_path__ + "static/media/025_IMG_5498.87940df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/025_IMG_5498.png
// module id = 591
// module chunks = 0